import Tabs2 from './Tabs2';

export default Tabs2;
